import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
  Grid,
  TableFooter,
} from "@mui/material";
import dayjs from "dayjs";
import api from "../../../utils/Url";
import SwipeableTemporaryDrawer from "./SwipeableTemporaryDrawer";
import { toast } from "react-toastify";

import ToastApp from "../../../ToastApp";
import { useNavigate } from "react-router-dom";

const StockLedgerTable = ({ data, title }: { data: any[]; title: any }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState<any>(null);

  const [IsResult, setResult] = useState("");
  const [IsPath, setPath] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    const lowerCaseQuery = searchQuery.toLowerCase();

    const filtered = data.filter((row) => {
      const calculatedBal = (row.inQty || 0) - (row.outQty || 0);
      return (
        (row.voucherType?.toLowerCase() || "").includes(lowerCaseQuery) ||
        dayjs(row.voucherDate || "")
          .format("DD-MMM-YYYY")
          .includes(lowerCaseQuery) ||
        (row.inQty?.toString() || "0").includes(lowerCaseQuery) ||
        (row.outQty?.toString() || "0").includes(lowerCaseQuery) ||
        (row.rate?.toString() || "0").includes(lowerCaseQuery) ||
        (row.totalInAmount?.toString() || "0").includes(lowerCaseQuery) ||
        (row.totalOutAmount?.toString() || "0").includes(lowerCaseQuery) ||
        calculatedBal.toString().includes(lowerCaseQuery)
      );
    });
    setFilteredData(filtered);
  }, [searchQuery, data]);

  const totalInQty = filteredData.reduce(
    (acc, row) => acc + (row.inQty || 0),
    0
  );
  const totalOutQty = filteredData.reduce(
    (acc, row) => acc + (row.outQty || 0),
    0
  );
  const totalBalQty = filteredData.reduce(
    (acc, row) => acc + (row.balQty || 0),
    0
  );


  const NavigateToEdit = () => {
    let Path = IsPath;
    navigate(Path, {
      state: IsResult,
    });
  };


  const fetchApiData = async (name: string, id: any, transId: any, IssueId: any, retId: any) => {
    console.log("naem, id", name, id, transId);
    try {
      let endpoint = "";
      let collectData;
      let path = "";
      if (name === "StockGeneral") {
        collectData = {
          voucherId: -1,
          stockBinId: 5,
          itemId: id,
        };
      } else if (name === "PurchaseReturn") {
        collectData = {
          id: transId,
          // documentNo: String(id),
          documentNo: "",
          "show": true,
          "exportOption": "",
          "fromDate": "1999-01-14T06:12:12.402Z",
          "toDate": new Date().toISOString(),
          "type": 0
        };
      } else if (name === "StaffIssue") {
        collectData = {
          "issueId": IssueId,
          "indentId": -1,
          "empId": -1
        };
      } else if (name === "StaffReturn") {
        collectData = {
          "returnId": retId,
          "returnType": ""
        };
      }
      else {
        collectData = { id: id, "show": true, "exportOption": ".pdf" };
      }

      switch (name) {
        case "PurchaseInvoice":
          endpoint = "PurchaseInvoice/GetPurchaseInvoice";
          path = `/Inventory/EditPurchaseInvoice`;

          break;
        case "StaffIssue":
          endpoint = "StaffItemIssue/GetItemIssue";
          path = `/Inventory/EditStaffItemIssue`;
          break;
        case "StaffReturn":
          endpoint = "ItemReturn/GetItemReturn";
          path = `/Inventory/EditStaffItemReturn`;
          break;
        case "PurchaseReturn":
          endpoint = "PurchaseReturn/GetPurchaseReturn";
          path = `/Inventory/EditPurchaseReturn`;
          break;
        case "StockGeneral":
          endpoint = "StockLedger/GetStockReport";
          path = `/Inventory/StockLedger`;
          break;
        default:
          toast.error("wait network problem");
          break;
      }

      const response = await api.post(endpoint, collectData);
      const result = response?.data?.data;

      setPath(path);
      setResult(result[0])


      console.log("response", result);

      if (result?.length > 0) {
        setDrawerData(result[0]);
        setOpenDrawer(true);
      } else {
        console.log("No data found.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  return (
    <div>
      <ToastApp />
      {drawerData && (
        <SwipeableTemporaryDrawer
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          userData={drawerData}
          title={`${title} Details`}
          NavigationPage={NavigateToEdit}

        />
      )}
      <Grid item xs={12} container>
        <Grid item sm={4} lg={4} xs={12}>
          <TextField
            label="Search Records"
            variant="outlined"
            fullWidth
            size="small"
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ marginBottom: "1rem" }}
          />
        </Grid>
      </Grid>
      <TableContainer
        component={Paper}
        style={{ maxHeight: "400px", overflowY: "auto" }}
      >
        <Table stickyHeader>
          <TableHead
            style={{
              backgroundColor: "#2B4593",
              color: "white",
              fontWeight: 600,
            }}
          >
            <TableRow>
              <TableCell
                style={{
                  backgroundColor: "#2B4593",
                  color: "white",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                Sr. No
              </TableCell>
              <TableCell
                style={{
                  backgroundColor: "#2B4593",
                  color: "white",
                  fontWeight: 600,
                  textAlign: "center", // Align Voucher Type to center
                }}
              >
                Voucher Type
              </TableCell>
              <TableCell
                style={{
                  backgroundColor: "#2B4593",
                  color: "white",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                Voucher Date
              </TableCell>
              <TableCell
                style={{
                  backgroundColor: "#2B4593",
                  color: "white",
                  fontWeight: 600,
                  textAlign: "right", // Align Rate to right
                }}
              >
                Rate
              </TableCell>
              <TableCell
                style={{
                  backgroundColor: "#2B4593",
                  color: "white",
                  fontWeight: 600,
                  textAlign: "right", // Align In Quantity to right
                }}
              >
                In Quantity
              </TableCell>
              <TableCell
                style={{
                  backgroundColor: "#2B4593",
                  color: "white",
                  fontWeight: 600,
                  textAlign: "right",
                }}
              >
                Out Quantity
              </TableCell>
              <TableCell
                style={{
                  backgroundColor: "#2B4593",
                  color: "white",
                  fontWeight: 600,
                  textAlign: "right", // Align Balance Quantity to right
                }}
              >
                Balance Quantity
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length > 0 ? (
              filteredData.map((row) => (
                <TableRow key={row.id}>
                  <TableCell align="center">{row.serialNo}</TableCell>
                  <TableCell align="center">
                    <a
                      onClick={() =>
                        fetchApiData(
                          row.voucherType,
                          row.voucherType == "StockGeneral" ? row.itemId : row.voucherId,
                          row.voucherType == "PurchaseReturn" ? row.companyId : row.id,
                          row.voucherType == "StaffIssue" ? row.companyId : row.id,
                          row.voucherType == "StaffReturn" ? row.companyId : row.id
                        )
                      }
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "blue",
                      }}
                    >
                      {row.voucherType}
                    </a>
                  </TableCell>
                  <TableCell align="center">
                    {row.voucherDate ? dayjs(row.voucherDate).format("DD-MMM-YYYY") : "--"}
                  </TableCell>
                  <TableCell align="right">{row.rate}</TableCell>
                  <TableCell align="right">{row.inQty}</TableCell>
                  <TableCell align="right">{row.outQty}</TableCell>
                  <TableCell align="right">{row.balQty}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow
              style={{ backgroundColor: "#f3f3f3", fontWeight: "bold" }}
            >
              <TableCell
                style={{ color: "black", fontWeight: 600, fontSize: "14px" }}
                align="center"
                colSpan={4}
              >
                Total
              </TableCell>
              <TableCell
                style={{ color: "black", fontWeight: 600, fontSize: "14px" }}
                align="right"
              >
                {totalInQty.toFixed(2)}
              </TableCell>
              <TableCell
                style={{ color: "black", fontWeight: 600, fontSize: "14px" }}
                align="right"
              >
                {totalOutQty.toFixed(2)}
              </TableCell>
              <TableCell
                style={{ color: "black", fontWeight: 600, fontSize: "14px" }}
                align="right"
              >
                {totalBalQty.toFixed(2)}
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

    </div>
  );
};

export default StockLedgerTable;
